import { ReactComponent as Logo } from '../../assets/icons/setting 1.svg'

const Setting = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Setting
